'use strict';
var population = document.querySelectorAll('.population');
var totalPopulationCount = 0;
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = population[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var item = _step.value;
        totalPopulationCount += Number(item.textContent.replace(/,/g, ''));
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
var averagePopulationResult = Math.round(totalPopulationCount / population.length);
var totalPopulation = document.querySelector('.total-population');
var avaragePopulation = document.querySelector('.average-population');
totalPopulation.textContent = totalPopulationCount.toLocaleString('en-US');
avaragePopulation.textContent = averagePopulationResult.toLocaleString('en-US');

//# sourceMappingURL=js_get_data_DOM.2a746a5c.js.map
